export default __webpack_public_path__ + "static/generativeAI-6917c661ad197f11dbb70a30d6298f45.svg";